import { IRewardData } from '../Utility/RewardHelper';
import { RewardType } from '../Utility/Rewards/RewardType';
import { AdvertisementArea, AdvertisementType, IAdvertisementPlacement } from '../Utility/SDK/Advertisement';
import DateHelper from '../Utility/DateHelper';
import { IGameConfig } from 'Utility/IGameConfig';
import { Platform } from 'Utility/Platform';

export const AD_SPACES_WITHOUT_COUNTER_INCREMENT: AdvertisementArea[] = [
    AdvertisementArea.DOUBLE_HARVEST,
    AdvertisementArea.GET_NEW_QUEST,
];

export const AD_COINS_REWARD: IRewardData = {
    type: RewardType.COINS,
    value: 1000,
};

export const INTERSTITIAL_START_LEVEL: number = 5;
export const INTERSTITIAL_FREQUENCY: number = 1;

export class AdsConfig {
    public static getInterstitialDefault(config: IGameConfig): IAdvertisementPlacement {
        return {
            id: config.adInterstitialDefaultID,
            type: AdvertisementType.INTERSTITIAL,
        };
    }

    public static getRewardedNoCoins(config: IGameConfig): IAdvertisementPlacement {
        return {
            id: config.adRewardedNoCoinsID,
            type: AdvertisementType.REWARDED,
        };
    }

    public static getRewardedWatchToPlay(config: IGameConfig): IAdvertisementPlacement {
        const type =
            config.platform !== Platform.FACEBOOK ? AdvertisementType.REWARDED : AdvertisementType.WATCH_TO_PLAY;

        return {
            id: config.adRewardedWatchToPlayID,
            type,
        };
    }

    public static getDoubleHarvest(config: IGameConfig): IAdvertisementPlacement {
        return {
            id: config.adRewardedDoubleHarvestID,
            type: AdvertisementType.REWARDED,
        };
    }

    public static getNewQuest(config: IGameConfig): IAdvertisementPlacement {
        return {
            id: config.adRewardedGetNewQuest,
            type: AdvertisementType.REWARDED,
        };
    }
}

export const WATCH_TO_PLAY_LEVEL: number = 7;
export const ADS_BEFORE_COOLDOWN: number = 10000;
export const AD_COOLDOWN_TIME: number = DateHelper.Hour * 4;
export const AD_INCATIVE_RESET_TIME: number = DateHelper.Hour * 4;
